module.exports = __webpack_public_path__ + "static/media/300-hours-small-EN.74da7be6.png";